const HOTEL_LOCATION = [
    'Airport', 'City', 'Resort', 'Suburban', 'North Suburb', 'South Suburb', 'East Suburb', 'West Suburb'
]

const DISTANCE_UNIT = [
    "Mile(s)", "Kilometer(s)", "Block(s)"
]

const DIRECTIONS = [
    'N',
    'NE',
    'NW',
    'S',
    'SE',
    'SW',
    'E',
    'W'
]

const YES_NO = [
    'Yes','No'
]


const ACCURACY = [
    "Exact",
"Block",
"Street",
"Intersection",
"Zip9Code",
"Zip7Code",
"Zip5Code",
"City",
"State",
"Country",
"County",
"Property"
]

export {
    HOTEL_LOCATION,
    DISTANCE_UNIT,
    DIRECTIONS,
    YES_NO,
    ACCURACY
}